export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WA_NUMBER = "40720629567";
export const WA_DISPLAY = "0720 629 567";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
